//
//
//
//
//
//
//
//
//
//
//
import FaqQuestion from './FaqQuestion';
export default {
  name: 'Faq',
  components: {
    FaqQuestion
  },

  data() {
    return {
      faqQuestions: [{
        id: 'faqQuestion-1',
        questionTitle: 'Why does Extra exist?',
        questionAnswer: 'Today, there are over 100 million Americans who dont want, or cant get a credit card. Yet there are very few alternatives for establishing your credit other than with a risky Credit Card. Our mission is to make credit building safer and more accessible for everyone. Extra, the first debit card that builds your credit history and earns rewards points just like a credit card.'
      }, {
        id: 'faqQuestion-2',
        questionTitle: 'Why is having good credit actually important?',
        questionAnswer: 'Getting a lot of the nice things in life depend heavily on your credit score. Lenders use your credit score to help determine whether to approve you for a line of credit as well as what interest rate and terms they can offer you. Having a higher credit score means that you’ll generally pay lower interest rates on things like a car lease or a mortgage for a house—planning for your financial future starts with building your credit score.'
      }, {
        id: 'faqQuestion-3',
        questionTitle: 'How much does Extra Cost?',
        questionAnswer: 'Most credit products make money from predatory interest rates and hidden fees. (even the "free" ones). We believe in upfront and transparent pricing which is why Extra only charges a flat monthly subscription rate starting at just $7. This way we can give our members peace of mind by building their credit with the money they have and never having to worry about steep interest fees.'
      }, {
        id: 'faqQuestion-4',
        questionTitle: 'What makes Extra different than other debit cards?',
        questionAnswer: `Most debit cards don’t offer rewards everywhere you swipe and have no ability to build or establish credit. Extra is the first debit card that lets you earn both in real-time. We give you the best parts of a credit card while spending the money that you actually have. Big banks don't do this with their debit cards because they want to up-sell you into a credit card, which makes them more money.`
      }]
    };
  }

};